export const DEVICE_STATES = [
  'pendingInstall',
  'inactive',
  'active',
  'suspended',
  'terminated',
  'pendingUninstall',
  'uninstalled',
  'uninstalledClient',
  'pendingRelocation',
  'pendingTransfer',
  'destroyed',
  'pendingReturn',
  'waitingPower',
  'waitingClientSwap',
] as const

export type DeviceState = typeof DEVICE_STATES[number]

// The subset DeviceAssignLoc accepts — the API rejects anything else on assignment.
export const ASSIGNABLE_DEVICE_STATES = [
  'pendingInstall',
  'active',
  'waitingPower',
] as const satisfies readonly DeviceState[]

export type AssignableDeviceState = typeof ASSIGNABLE_DEVICE_STATES[number]

export const DEVICE_STATE_LABELS: Record<DeviceState, string> = {
  pendingInstall: 'Pending Install',
  inactive: 'Inactive',
  active: 'Active',
  suspended: 'Suspended',
  terminated: 'Terminated',
  pendingUninstall: 'Pending Uninstall',
  uninstalled: 'Uninstalled',
  uninstalledClient: 'Uninstalled (Client)',
  pendingRelocation: 'Pending Relocation',
  pendingTransfer: 'Pending Transfer',
  destroyed: 'Destroyed',
  pendingReturn: 'Pending Return',
  waitingPower: 'Waiting Power',
  waitingClientSwap: 'Waiting Client Swap',
}

export const deviceStateLabel = (state: DeviceState) => DEVICE_STATE_LABELS[state]

// Replaces the retired `deviceSettings.active` boolean wherever a device must count as
// active — currently the Home dashboard offline and on-battery counts and their percentages.
// `waitingClientSwap` counts: the device being replaced stays installed and reporting until the
// client makes the physical swap (confirmed 2026-09-25).
export const COUNTED_AS_ACTIVE_DEVICE_STATES: ReadonlySet<DeviceState> = new Set([
  'active',
  'suspended',
  'pendingTransfer',
  'waitingClientSwap',
])

export const isCountedAsActive = (state: DeviceState) =>
  COUNTED_AS_ACTIVE_DEVICE_STATES.has(state)
